import { render, staticRenderFns } from "./YandexOutageNotification.vue?vue&type=template&id=09290983&scoped=true"
import script from "./YandexOutageNotification.vue?vue&type=script&lang=js"
export * from "./YandexOutageNotification.vue?vue&type=script&lang=js"
import style0 from "./YandexOutageNotification.vue?vue&type=style&index=0&id=09290983&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09290983",
  null
  
)

export default component.exports